import { useCallback } from "react";
import { queriesNotifications } from "@query";
import { useSession } from "@hooks/useSession";
import { removeNotificationFromCache } from "../helpers";

type UseMutationConfig = Parameters<
  typeof queriesNotifications.dismissNotification.useMutation
>[0];

export const useMutationDismissNotification = (config?: UseMutationConfig) => {
  const { personId } = useSession();
  const [dismissNotification, meta] =
    queriesNotifications.dismissNotification.useMutation(config);

  const dismiss = useCallback(
    (notificationId: string) => {
      removeNotificationFromCache(notificationId);
      return dismissNotification({ personId, notificationId });
    },
    [dismissNotification, personId]
  );

  return [dismiss, meta] as const;
};
